
import {
    CLEAR_MEASURE_LIST,
    SET_MEASURE_IN_LIST,
    SET_MEASURE_TOOL,
    SET_MEASURE_VALUES
} from '../sagas/measure';

const initialState = {
    measureList: [],
    tool: null,
    values: null
};

function clearMeasureList(state, action) {
    return {
        ...state,
        measureList: [],
        values: null
    };
}

function setMeasureInList(state, action) {
    let needAppend = true;
    let measureList = state.measureList.map(item => {
        if (item.id === action.measure.id) {
            needAppend = false;
            return action.measure;
        } else {
            return item;
        }
    });

    if (needAppend) {
        measureList.push(action.measure)
    }

    return {
        ...state,
        measureList: measureList
    };
}

function setMeasureTool(state, action) {
    return {
        ...state,
        tool: action.tool,
        values: null
    };
}

function setMeasureValues(state, action) {
    return {
        ...state,
        values: action.values
    };
}

function measure(state = initialState, action) {
    switch (action.type) {

        case CLEAR_MEASURE_LIST:
            return clearMeasureList(state, action);

        case SET_MEASURE_IN_LIST:
            return setMeasureInList(state, action);

        case SET_MEASURE_TOOL:
            return setMeasureTool(state, action);

        case SET_MEASURE_VALUES:
            return setMeasureValues(state, action);

        default:
            return state;
    }
}

export default measure;
